import React, { useEffect, useState } from 'react';
import CommonIcon from './customicon';

const Message = ({ message, type = 'info' }) => {
  const [visible, setVisible] = useState(true);

  // Automatically hide the alert after 40 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
       setVisible(false);
    }, 10000); // 40 seconds
    return () => clearTimeout(timer); // Cleanup the timer
  }, []);

  // Define icon and alert style based on type
  let icon, alertClass;
  switch (type) {
    case 'success':
      icon = <CommonIcon iconName="CircleCheckBig" size={"16px"} color="var(--vz-alert-color)" />;
      alertClass = 'alert alert-success';
      break;
    case 'error':
      icon = <CommonIcon iconName="CircleX" size={"16px"} color="var(--vz-alert-color)" />;
      alertClass = 'alert alert-danger';
      break;
    case 'info':
    default:
      icon = <CommonIcon iconName="Info" size={"16px"} color="var(--vz-alert-color)" />;
      alertClass = 'alert alert-info';
      break;
  }

  // Close button handler
  const handleClose = () => {
    setVisible(false);
  };

  // Don't render anything if the alert is not visible
  if (!visible) {
    return null;
  }

  return (
    <div className={alertClass+" custom-toast"} role="alert" >
      {/* Close button in the top right corner */}
      <button
        onClick={handleClose}
        style={{
          position: 'absolute',
          top: "-16px",
          right: "-9px",
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: 'var(--vz-alert-color)',
          fontSize: '20px'
        }}
      >
        <CommonIcon iconName="CircleX" size={"20px"} color="#000" />
      </button>

      {/* Icon and message */}
      {icon} {message || 'This is a success alert—check it out!'}
    </div>
  );
};

export default Message;
